var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"form__link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.sendRequest.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.deletionStatus ? 'Восстановить анкету' : 'Удалить анкету'))])
}
var staticRenderFns = []

export { render, staticRenderFns }